<template>
    <div>
        <div class="row" v-if="log">

            <div class="col-11">
                <log-content ref="log"
                    :log="log"
                    :types="types"
                    :registration="session.registration"
                    :degree="session.degree"
                    :simulation="session.simulation"
                    :session="session"
                    :stats="stats"
                    :observations="observations"
                    :competencies="competencies"
                    :lang="session.degree.lang"
                    :filters="filters"
                    :features="features"
                    @filtersChanged="filters = $event"
                    @progressChanged="progress = $event"
                    @visibilityChanged="visibility = $event"
                    @observationChanged="reloadSession"
                    @refresh="reloadStats">
                </log-content>
        
                <div class="text-center fixed-bottom mt-1" :class="{ showButtons: showButtons }">
                    <base-button class="action-button" type="primary" @click.prevent="features.openConfiguration()">
                        <i class="fas fa-chevron-left mr-1"></i> {{ $t('sessions.configuration') }}
                    </base-button>

                    <base-button class="action-button" type="primary" @click.prevent="features.openEvaluation()">
                        {{ $t('sessions.evaluation') }} <i class="fas fa-chevron-right ml-1"></i>
                    </base-button>
                </div>
            </div>
            <div class="col-1">
                <features
                    :log="log"
                    :registration="session.registration"
                    :degree="session.degree"
                    :simulation="session.simulation"
                    :session="session"
                    :stats="stats"
                    :competencies="competencies"
                    :lang="session.degree.lang"
                    :types="types"
                    :filters="filters"
                    :progress="progress"
                    :visibility="visibility"
                    :features="features"
                    @filtersChanged="filters = $event"
                    @timeslotClicked="$refs.log.scrollToTimeslot($event)"
                    @refresh="reloadStats"
                >
                </features>
            </div>
        </div>
        <back-to-top></back-to-top>
    </div>
</template>

<script>
    import SessionFeatures from './SessionFeatures'
    import LogContent from '../log/LogContent'
    import Features from '../log/GlobalFeatures'

    export default {

        components: {
            LogContent, Features
        },

        props: {

            session: {
                type: Object,
                required: true
            },

            log: {
                type: Object,
                required: true
            },

            types: {
                type: Object,
                required: true
            },
            
            competencies: {
                type: Object,
                default: null
            },
            
            stats: {
                type: Object,
                default: null
            },
            
            observations: {
                type: Object,
                default: null
            },
        },

        data() {
            return {
                features: new SessionFeatures(this.$router, this.$auth, this.session),
                showButtons: false,
                filters: {
                    selectedTypes: [],
                    selectedCompetencies: [],
                    showCompetencies: false,
                },
                progress: {},
                visibility: {},
            }
        },

        mounted() {
            $(window).scroll(() => {
                this.showButtons = $(window).scrollTop() > 300
            });
        },

        methods: {

            reloadStats() {
                this.$emit('reload-stats')
                
                // If we are offline, we reload the session too because we want to refresh the offline status badge.
                if (this.session.sync) {
                    this.reloadSession()
                } 
            },

            reloadSession() {
                this.$emit('reload-session')
            }
        }
    }
</script>

<style lang="css" scoped>

    .fixed-bottom {
        position: sticky;
        bottom: 30px;
        z-index: 1000;
        pointer-events: none;
        opacity: 0;
        visibility: hidden;
        transition:
            opacity .5s,
            visibility .5s;
    }

    .action-button {
        pointer-events: auto;
    }

    .showButtons {
        opacity: 1;
        visibility: visible;
    }

</style>

